function Ruler({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width="${dimensions || 22}" height="${(dimensions * 12) / 22 || 12}" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 0H2C0.9 0 0 0.9 0 2V10C0 11.1 0.9 12 2 12H20C21.1 12 22 11.1 22 10V2C22 0.9 21.1 0 20 0ZM20 10H2V2H4V6H6V2H8V6H10V2H12V6H14V2H16V6H18V2H20V10Z" fill="${col}"/>
  </svg>
  `;

  return baseXml;
}

export default Ruler;
